import { render, staticRenderFns } from "./createSubbrand.vue?vue&type=template&id=51b76f6e&"
import script from "./createSubbrand.vue?vue&type=script&lang=js&"
export * from "./createSubbrand.vue?vue&type=script&lang=js&"
import style0 from "./createSubbrand.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/data/build/src/git_yodlee_subbrandingtool_RELjan2022/engineering/components/subbrandingtool/client/1.0/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VContainer,VFlex,VLayout,VSpacer})
